import React from 'react';
import { Card } from '../../ui/Card';
import { formatEuro } from '../../../utils/currency';
import { courseTotalCost, externalProductCost, teachingHours, teachingTotal } from '../../../utils/trainingCourses';
import { TrainingCourseDraft } from '../../../types/trainingCourse';
interface CourseCostSummaryProps {
  course: TrainingCourseDraft;
}
interface CostRow {
  label: string;
  value: number;
  detail?: string;
}
export function CourseCostSummary({
  course
}: CourseCostSummaryProps) {
  const teacherCount = (course.teachers || []).filter(t => t.teacherId).length;
  const hours = teachingHours(course);
  const rows: CostRow[] = [course.status === 'ondemand' ? {
    label: 'Costo realizzazione corso',
    value: course.productionCost || 0,
    detail: 'Totale complessivo'
  } : {
    label: 'Importo complessivo docenza',
    value: teachingTotal(course),
    detail: `${teacherCount} ${teacherCount === 1 ? 'docente' : 'docenti'} · ${hours.toLocaleString('it-IT')} ore`
  }, {
    label: 'Noleggio attrezzature',
    value: course.equipmentAmount || 0,
    detail: course.equipmentType
  }, {
    label: 'Affitto locali',
    value: course.roomRentalAmount || 0
  }, {
    label: 'Altri costi',
    value: course.otherCostsAmount || 0
  }, ...(course.externalProduct ? [{
    label: 'Costo prodotto esterno',
    value: externalProductCost(course),
    detail: course.externalSupplier
  }] : [])];
  return <Card title="Riepilogo costi" noHoverShadow data-id="element-1136" data-mp="34m95lbi34gej">
      <dl className="space-y-4" data-id="element-1137" data-mp="2zs4x2nt680bc">
        {rows.map(row => <div key={row.label} className="flex items-start justify-between gap-4" data-id="element-1138" data-mp="2vrunl1666rrq">
            <dt data-id="element-1139" data-mp="3s9h7djgb17bt">
              <span className="text-sm text-slate-600" data-id="element-1140" data-mp="3s98x7zbkgg4b">{row.label}</span>
              {row.detail && <span className="block text-xs text-slate-400 mt-0.5" data-id="element-1141" data-mp="3ni8wsk38nfx2">
                  {row.detail}
                </span>}
            </dt>
            <dd className="text-sm font-medium text-slate-800 tabular-nums whitespace-nowrap" data-id="element-1142" data-mp="1lnbhfe6haozr">
              {formatEuro(row.value)}
            </dd>
          </div>)}
      </dl>
      <div className="mt-5 pt-5 border-t border-slate-100 flex items-baseline justify-between gap-4" data-id="element-1143" data-mp="1buvx4a7plobp">
        <span className="text-sm font-medium text-slate-600" data-id="element-1144" data-mp="1gsp5n9whiuf5">Totale costi</span>
        <span className="text-2xl font-bold text-seform-navy tabular-nums" data-id="element-1145" data-mp="12txv1xgtzqvr">
          {formatEuro(courseTotalCost(course))}
        </span>
      </div>
    </Card>;
}